module.exports = __webpack_public_path__ + "img/cjcl5.f8e5be83.png";